// src/components/ui/primitives.jsx
import { cn } from "../../lib/utils";

export function Card({ className, children, ...props }) {
  return (
    <div className={cn("card p-4", className)} {...props}>
      {children}
    </div>
  );
}

export function SectionLabel({ children, className }) {
  return (
    <p className={cn("label mb-2 px-1", className)}>{children}</p>
  );
}

export function Divider({ className }) {
  return <div className={cn("divider my-3", className)} />;
}

export function Badge({ variant = "green", children, className }) {
  const variants = {
    green: "pill-green",
    red: "pill-red",
    amber: "pill-amber",
    blue: "pill-blue",
    purple: "pill-purple",
  };
  return (
    <span className={cn("pill", variants[variant], className)}>{children}</span>
  );
}

export function Skeleton({ className }) {
  return <div className={cn("skeleton h-4 w-full", className)} />;
}

export function AccountIcon({ initials, color = "blue" }) {
  const colors = {
    blue: "bg-accent-blue-muted text-accent-blue",
    green: "bg-accent-green-muted text-accent-green",
    teal: "bg-accent-green-muted text-accent-green-dim",
    amber: "bg-accent-amber-muted text-accent-amber",
    purple: "bg-accent-purple-muted text-accent-purple",
    red: "bg-accent-red-muted text-accent-red",
  };
  return (
    <div
      className={cn(
        "w-9 h-9 rounded-full flex items-center justify-center text-[11px] font-semibold font-mono flex-shrink-0",
        colors[color] || colors.blue
      )}
    >
      {initials}
    </div>
  );
}

export function LoadingDots() {
  return (
    <div className="flex items-center gap-1">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="w-1.5 h-1.5 rounded-full bg-accent-green animate-pulse-slow"
          style={{ animationDelay: `${i * 150}ms` }}
        />
      ))}
    </div>
  );
}

export function ChangeIndicator({ value, className }) {
  const isPositive = value >= 0;
  return (
    <span
      className={cn(
        "pill text-[10px]",
        isPositive ? "pill-green" : "pill-red",
        className
      )}
    >
      {isPositive ? "+" : ""}
      {value.toFixed(1)}%
    </span>
  );
}
